import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "@tanstack/react-router";

import { getDeal, type Deal } from "@/api/client";
import { useCurrentUser } from "@/auth/useCurrentUser";
import { DealDetailContent } from "@/components/deals/DealDetailContent";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";

export function PartnerDealDetailRoute() {
  const { accessToken } = useCurrentUser();
  const navigate = useNavigate();
  const { dealId } = useParams({ from: "/dashboard/partner/deals/$dealId" });

  const deal = useQuery<Deal>({
    queryKey: ["deals", "detail", dealId, accessToken],
    queryFn: () => getDeal(accessToken!, dealId),
    enabled: !!accessToken && !!dealId,
  });

  if (deal.isLoading)
    return (
      <p role="status" className="container py-6">
        Loading...
      </p>
    );
  if (deal.error)
    return (
      <div className="container py-6">
        <p role="alert">Couldn't load this deal.</p>
        <p className="mt-2 text-sm">
          <Link to="/dashboard/partner/deals">Back to my deals</Link>
        </p>
      </div>
    );
  if (!deal.data) return null;

  const d = deal.data;
  return (
    <div className="container py-6">
      <p className="mb-2 text-sm text-muted-foreground">
        <Link to="/dashboard/partner/deals">&larr; Back to my deals</Link>
      </p>

      {/* Header — [Client Name] / [Deal ID]; the status pill lives in the
          Status section below (CHP-234, strict trim). */}
      <Card className="mb-4">
        <CardHeader>
          <CardTitle>{d.client_name}</CardTitle>
          {d.deal_id_display && (
            <p className="mt-1 text-sm font-mono text-muted-foreground">{d.deal_id_display}</p>
          )}
        </CardHeader>
      </Card>

      <DealDetailContent
        deal={d}
        onActionDone={() => void navigate({ to: "/dashboard/partner/deals" })}
        showDealId={false}
      />
    </div>
  );
}
